import { saveAs } from 'file-saver'

import { getTranslation } from 'src/commons/i18n'
import { IJson } from 'src/commons/types'

import { insert } from '../helpers'

export const getHeadersFromJsonList = (jsonList: IJson[]) => {
  const headers: string[] = []
  // We do it this way because of dynamic jsons such as
  // [{"a":1, "b":1}, {"a":1, "c":1}]
  jsonList.forEach((json) => {
    Object.keys(json).forEach((key: string, index: number) => !headers.includes(key) && insert(headers, key, index))
  })
  return headers
}

export const JsonListToCsv = (jsonList: IJson[], headers: string[]) => {
  const { t } = getTranslation()
  const separator = t('csv.separator')

  let csvContent = `${headers.join(separator)}\n`

  jsonList.forEach((json) => {
    csvContent += `${headers.map((column: string) => (json[column] ? json[column] : 0)).join(separator)}\n`
  })

  return csvContent
}

export const GraphDataToCsv = (rows: any[][], headers: string[]) => {
  const { t } = getTranslation()
  const separator = t('csv.separator')

  let csvContent = `${headers.join(separator)}\n`

  rows.forEach((row) => {
    csvContent += `${row.join(separator)}\n`
  })

  return csvContent
}

// A spreadsheet evaluates a cell starting with one of these as a formula
const FORMULA_PREFIXES = ['=', '+', '-', '@', '\t', '\r']

function toCsvCell(value: string): string {
  const text = FORMULA_PREFIXES.some((prefix) => value.startsWith(prefix)) ? `'${value}` : value
  return `"${text.replace(/"/g, '""')}"`
}

export const TextRowsToCsv = (rows: string[][], headers: string[]) => {
  const { t } = getTranslation()
  const separator = t('csv.separator')

  return `${[headers, ...rows].map((row) => row.map(toCsvCell).join(separator)).join('\n')}\n`
}

export const downloadCsv = (csvContent: string, filename: string) => {
  const blob = new Blob([String.fromCharCode(0xfeff), csvContent], {
    type: 'text/csv;charset=utf-8',
  })

  /* We should be able to pass { autoBom: true } as tird argmuent to saveAs
     but it doesn't work... so we will this append the 0xFEFF marker at the
     beginning of the file
  */
  saveAs(blob, filename + '.csv')
}

export const downloadJson = (jsonContent: string, filename: string) => {
  const blob = new Blob([jsonContent], {
    type: 'application/json;charset=utf-8',
  })

  saveAs(blob, filename + '.json')
}
